<template>
  <CourseList
    level-key="beginnerLevel"
    fetch-action="getCourseBeginners"
    getter-name="courseBeginners"
  />
</template>

<script>
import CourseList from "@/components/CourseList.vue";

export default {
  name: "BeginnerCourse",
  components: { CourseList },
};
</script>
